import type { System } from './System';

export class SystemRunner {
  private readonly systems: System[] = [];
  private initialized = false;

  register(system: System): void {
    this.systems.push(system);
    if (this.initialized) system.init?.();
  }

  init(): void {
    if (this.initialized) return;
    this.initialized = true;
    for (const system of this.systems) system.init?.();
  }

  update(dt: number): void {
    for (const system of this.systems) system.update(dt);
  }

  dispose(): void {
    for (const system of this.systems) system.dispose?.();
    this.systems.length = 0;
    this.initialized = false;
  }
}
